import React from "react";
import {FormControl, ControlLabel, Button, Alert} from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import immutable from 'immutable';
import moment from 'moment';
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";

export default class CreateDelegateForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            message: ""
        }

        this.onSave = this.onSave.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const vm = immutable.fromJS(nextProps.vm).toJS();
        vm.errors = [];
        vm.message = "";
        this.setState(vm);
    }

    onSave(payload) {
        let self = this;
        let clone = this.state;
        clone.domain = payload.domain;
        clone.username = payload.username;
        clone.startDate = payload.startDate;
        clone.endDate = payload.endDate;
        clone.errors = this.validate(payload);

        if (clone.errors.length > 0) {
            this.setState(clone);
        } else {
            context.message({
                show: true,
                type:"loading",
                message: "Adding delegate. Please wait..."
            });

            ajax.api()
            .post(`add-delegate`, {
                username: payload.username,
                domain: payload.domain,
                startDate: moment(payload.startDate).format("MM/DD/YYYY"),
                endDate: moment(payload.endDate).format("MM/DD/YYYY")
            })
            .then(function(res){
                context.message({
                    show: false
                });
                
                clone.message = "Added successfully";
                self.setState(clone);
                if (self.props.onSave) self.props.onSave(res.data);
            })
            .catch(function(err) {
                let data = err.response.data;

                if (data.ClassName === "ActionPortal.ValidationException") {
                    for(let key in data.Data.summary.validationResults)
                        clone.errors.push(data.Data.summary.validationResults[key]);
                } else {
                    clone.errors = [data.exceptionMessage || data.message];
                }

                self.setState(clone);
                context.message({
                    show: false,          
                });
            });
        }
    }

    validate(obj) {
        let msg = [];
        let now = moment();
        if (obj.domain == null || obj.domain.trim().length == 0) {
            msg.push("Domain is required");
        }

        if (obj.username == null || obj.username.trim().length == 0) {
            msg.push("Username is required");
        }

        if (obj.startDate == null){
            msg.push("Start Date is required");

        } else {
            if (obj.startDate.trim().length == 0)
                msg.push("Start Date is required");

            else if (!moment(obj.startDate))
                msg.push("Start Date is invalid");

            else if (now.format("YYYY-MM-DD") > moment(obj.startDate).format("YYYY-MM-DD"))
                msg.push("Start Date must not be before current date");
        }

        if (obj.endDate == null) {
            msg.push("End Date is required");

        } else {
            if (obj.endDate.trim().length == 0)
                msg.push("End Date is required");

            else if (!moment(obj.endDate))
                msg.push("End Date is invalid");

            else if (obj.startDate != null && moment(obj.startDate).format("YYYY-MM-DD") > moment(obj.endDate).format("YYYY-MM-DD"))
                msg.push("Start Date must be before End Date");

            else if (now.format("YYYY-MM-DD") > moment(obj.endDate).format("YYYY-MM-DD"))
                msg.push("End Date must not be before current date");
        }

        return msg;
    }

    render() {
        const self = this;
        let usernameInput = null, domainInput = null, startDateVal = this.state.startDate, endDateVal = this.state.endDate;

        let msgText = this.state.message;
        let msgClass = "";
        let msgStyle = "info";

        if (this.state.errors.length > 0) {
            msgStyle = "danger";
            msgText = <ul>{
                        this.state.errors.map(m => <li key={m}>{m}</li>)
                        }
                    </ul>;
        }
        else if (msgText == "") {
            msgClass = "ap-hidden";
        }
        else if (msgText.toUpperCase().indexOf("SUCCESS") > -1) {
            msgStyle = "success";
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <div>
                            <ControlLabel>Domain <span className="ap-color-red"> *</span></ControlLabel>
                            <FormControl type="text" placeholder="Domain"
                                defaultValue={this.state.domain}
                                inputRef={node => domainInput = node}></FormControl>
                        </div>
                        <div>
                            <ControlLabel>Username <span className="ap-color-red"> *</span></ControlLabel>
                            <FormControl type="text" placeholder="Username"
                                defaultValue={this.state.username}
                                inputRef={node => usernameInput = node}></FormControl>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="row">
                            <div className="col-md-6 col-lg-6">
                                <ControlLabel>Start Date <span className="ap-color-red"> *</span></ControlLabel>
                                <DatePicker placeholder="MM/DD/YYYY" value={this.state.startDate}
                                    onChange={(val, formattedVal) => startDateVal = val}
                                    onInput={(val, formattedVal) => startDateVal = val} />
                            </div>
                            <div className="col-md-6 col-lg-6">
                                <ControlLabel>End Date <span className="ap-color-red"> *</span></ControlLabel>
                                <DatePicker placeholder="MM/DD/YYYY" value={this.state.endDate}
                                    onChange={(val, formattedVal) => endDateVal = val}
                                    onInput={(val, formattedVal) => endDateVal = val} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <ControlLabel style={{fontSize: "20px"}}>&nbsp;</ControlLabel>
                                <Button onClick={() =>
                                    this.onSave({
                                        domain: domainInput.value,
                                        username: usernameInput.value,
                                        startDate: startDateVal,
                                        endDate: endDateVal})} className="btn-info ap-fullsize">ADD DELEGATE</Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row"> 
                    <div className="col-md-12 col-lg-12">
                        <Alert bsStyle={msgStyle} className={msgClass}>
                            {msgText}
                        </Alert>
                    </div>
                </div>
            </div>
        );
    }
}